import { LISCase } from "pwapi";

import ClinicName from "ui/components/ClinicName";
import UserFullName from "ui/components/UserFullName";

const CaseInfo = ({ c }: { c: LISCase }) => {
  return (
    <div className="CaseInfo">
      <p>
        {c?.patient?.last_name}, {c?.patient?.first_name}
      </p>
      <hr />
      <dl>
        <div>
          <dt>Ordering Provider</dt>
          <dd>
            <UserFullName id={c.ordering_doctor_id} />
          </dd>
        </div>
        <div>
          <dt>Clinic</dt>
          <dd>
            <ClinicName id={c.patient.clinic_id} />
          </dd>
        </div>
      </dl>
    </div>
  );
};

export default CaseInfo;
